export interface BaseOtp {
    id?: number;
    mobileNumber: string;
    otp: number;
    otpExpiringTime: Date;
}

export interface BaseUser {
    id?: number;
    name: string;
    email: string;
    userMobileNumber?: string;
    profileImage?: string;
    age?: number;
    hasCompletedTour?: boolean;
}

export interface UserDetailsAttributes extends BaseUser {
    id: number;
}

export interface UserInstance extends UserDetailsAttributes {
    createdAt?: Date;
    updatedAt?: Date;
}

export type NullableUser = UserInstance | null;

export interface BaseAddress {
    id?: number;
    userMobileNumber?: string;
    address: string;
    addressType?: string;
    city: string;
    houseNumber?: string;
    state: string;
    pincode: number;
    gpsCoordinate?: {
        latitude: number;
        longitude: number;
    };
    name?: string;
    isDefault?: boolean;
    isPreferred?: boolean;
    mobileNumber?: string;
}

export interface AddressDetailsAttributes extends BaseAddress {
    id: number;
    createdAt?: Date;
    updatedAt?: Date;
}

export type NullableAddress = AddressDetailsAttributes | null;
export type NullableAddresses = AddressDetailsAttributes[] | null;

export interface RegisteredUserDetails {
    id: number;
    mobileNumber: string;
    otp: number;
    otpExpiringTime: Date;
    createdAt: Date;
    updatedAt: Date;
    user: UserInstance;
    addresses: NullableAddresses;
}

export type NullableRegisteredUserDetails = RegisteredUserDetails | null;

export enum UserDetailStatus {
    Add = "Added Successfully",
    Update = "Updated Successfully",
    Delete = "Deleted Successfully",
    DeleteAddressFailed = "Failed to delete address",
    UpdateAddressFailed = "Failed to update address",
    AddAddressFailed = "Failed to add address",
    UpdateEmailFailed = "Failed to update email",
    AddUserDetailsFailed = "Failed to add user details",
    GetDefaultAddressFailed = "Failed to get default address",
    GetAllAddressesFailed = "Failed to get addresses",
    GetUserDetailsFailed = "Failed to get user details",
    UserDetailsCheckFailed = "User details check failed",
    ChangeProfileImage = "Change Profile Photo",
    AddProfileImage = "Add Profile Photo",
    FailedToUpdatePhoto = "Failed to update photo",
    TourStatusUpdated = "Tour status updated successfully",
    TourStatusUpdationFailed = "Failed to update tour status",
}

export interface SidebarItem {
    key: string;
    label: string;
}

export interface SidebarSection {
    class: string;
    label?: string;
    items: SidebarItem[];
}

export const SidebarSections: SidebarSection[] = [
    {
        class: "first-section",
        items: [{ key: "overview", label: "Overview" }],
    },
    {
        class: "second-section",
        label: "Order",
        items: [{ key: "order", label: "Orders & Status" }],
    },
    {
        class: "third-section",
        items: [
            { key: "coupon", label: "Coupons & Rewards" },
            { key: "structure", label: "My Structures" },
        ],
    },
    {
        class: "fourth-section",
        label: "Account",
        items: [
            { key: "profile", label: "Profile" },
            { key: "address", label: "Addresss" },
            { key: "", label: "Delete Account" },
        ],
    },
    {
        class: "fifth-section",
        label: "Legal",
        items: [
            { key: "term", label: "Terms & Condition" },
            { key: "policy", label: "Privacy Policy" },
        ],
    },
];
